import {
  Card,
  Table,
  Tag,
  Input,
  Button,
  Modal,
  Form,
  Select,
  Tooltip,
} from "antd";
import React, { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { showAuthLoader, hideAuthLoader } from "../../appRedux/actions/Auth";
import Service from "../../service";
import moment from "moment";
import { ArrowLeftOutlined, EyeOutlined } from "@ant-design/icons";
import ViewIcon from "../../assets/images/ViewIcon";
import { capitalizeFirst } from "../../util/YearOptions";
import NodataFoundIcon from "../../assets/images/NodataFoundIcon";
import EmpNameCodeCell from "../common/EmpNameCodeCell";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import ApprovalStatusCell from "../Approvals/ApprovalStatusCell";
import useCompanyDateFormat from "../../hooks/useCompanyDateFormat";
import { TABLE_PAGINATION, DEFAULT_PAGE_SIZE } from "../../constants/tablePagination";


function UserResignationList() {
  const dateFormat = useCompanyDateFormat();
  const [isModalOpenView, setIsModalOpenView] = useState(false);
  const [commentsView, setcomments] = useState("");
  const [reasonView, setReason] = useState("");
  const [showreasonRevoke, setshowReasonRevoke] = useState("");
  const [showReasonCancel, setshowReasonCancel] = useState("");
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [filterForm] = Form.useForm();
  const [isModalOpenFilter, setIsModalOpenFilter] = useState(false);
  const [seachEnabled, setSearchEnabled] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [Employees, setEmployees] = useState([]);
  const history = useHistory();

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: DEFAULT_PAGE_SIZE,
  });

  const { Option } = Select;
  const Search = Input.Search;
  const searchRef = useRef();
  useEffect(() => {
    getEmployeesResignList();
  }, [pagination.current, pagination.pageSize, searchText]);

  const showModalView = (id, comments, reason, revoke, cancel) => {
    setIsModalOpenView(true);
    setcomments(comments);
    setReason(reason);
    setshowReasonRevoke(revoke);
    setshowReasonCancel(cancel);
  };
  const handleOkView = () => {
    setIsModalOpenView(false);
  };
  const handleCancelView = () => {
    setIsModalOpenView(false);
    setcomments("");
    setReason("");
    setshowReasonRevoke("");
    setshowReasonCancel("");
  };

  const onSearch = (value) => {
    setSearchText(value);
    setPagination({ ...pagination, current: 1 });
  };
  const resetSearchFilter = (e) => {
    const keyCode = e && e.keyCode ? e.keyCode : e;
    switch (keyCode) {
      case 8:
        if (searchRef.current.state?.value?.length <= 1 && seachEnabled) {
          searchRef.current.state.value = "";
          setSearchText("");
          setSearchEnabled(false);
        }
        break;
      case 46:
        if (searchRef.current.state?.value?.length <= 1 && seachEnabled) {
          searchRef.current.state.value = "";
          setSearchText("");
          setSearchEnabled(false);
        }
        break;
      default:
        break;
    }
  };
  const getEmployeesResignList = async (filterData) => {
    try {
      dispatch(showAuthLoader());
      const reqBody = {
        pageNum: pagination.current,
        pageLimit: pagination.pageSize,
      };
      if (searchText && searchText !== "") {
        reqBody.search = searchText;
        setSearchEnabled(true);
      }

      const response = await Service.makeAPICall({
        methodName: Service.postMethod,
        api_url: Service.userResignList,
        body: reqBody,
      });

      dispatch(hideAuthLoader());
      if (response?.data?.data?.length > 0) {
        if (filterData?.isActive == true) {
          setPagination({
            ...pagination,
            total: response.data.metaData.totalFilteredCount,
            deactivetotal: response.data.metaData.totaldUsers,
          });
        } else {
          setPagination({
            ...pagination,
            total: response.data.metaData.totalFilteredCount,
          });
        }
        setEmployees(response.data.data);
      } else {
        setPagination({
          ...pagination,
          total: 0,
        });
        setEmployees([]);
      }
    } catch (error) {
      dispatch(hideAuthLoader());
      console.log(error);
    }
  };

  const columns = [
    {
      title: "Employee Name",
      dataIndex: "employee_name",
      key: "employee_name",
      render: (text, record) => <EmpNameCodeCell name={record?.employee_name} code={record?.emp_code} />,
    },
    {
      title: "Date Of Resignation",
      dataIndex: "date_of_resignation",
      key: "date_of_resignation",
      render: (text, record, index) => {
        return (
          <span>{moment(record?.resignation_date).format(dateFormat)}</span>
        );
      },
    },
    {
      title: "Last Date As Per Notice Period",
      dataIndex: "last_date_notice",
      key: "last_date_notice",
      render: (text, record, index) => {
        // The resolved day count sits next to the date it produced, so the
        // number is auditable without opening the policy screen.
        return (
          <span>
            {moment(record?.last_date_notice).format(dateFormat)}
            {record?.notice_period_days != null && (
              <span style={{ color: "#8c8c8c", marginLeft: 6 }}>
                ({record.notice_period_days} days)
              </span>
            )}
          </span>
        );
      },
    },
    {
      title: "Requested Last Date",
      dataIndex: "request_last_date",
      key: "request_last_date",
      render: (text, record, index) => {
        return (
          <span>{record?.request_last_date ? moment(record?.request_last_date).format(dateFormat) : " - "}</span>
        );
      },
    },
    {
      title: "Last Date",
      dataIndex: "last_date",
      key: "last_date",
      render: (text, record, index) => {
        if (record?.last_date) {
          return <span>{moment(record?.last_date).format(dateFormat)}</span>;
        } else {
          return <span>-</span>;
        }
      },
    },
    {
      title: "Accepted Date",
      dataIndex: "Accepted Date",
      key: "Accepted Date",
      render: (text, record, index) => {
        const AcceptedRecord = record.statusHistory.find(
          (history) => history.resignationStatus === "Accepted"
        );
        if (AcceptedRecord) {
          return (
            <span>
              {moment(AcceptedRecord.created_At).format(dateFormat)}
            </span>
          );
        } else {
          return <span>-</span>;
        }
      },
    },

    {
      title: "Rejected Date",
      dataIndex: "Rejected Date",
      key: "Rejected Date",
      render: (text, record, index) => {
        const RejectedRecord = record.statusHistory.find(
          (history) => history.resignationStatus === "Rejected"
        );
        if (RejectedRecord) {
          return (
            <span>
              {moment(RejectedRecord.created_At).format(dateFormat)}
            </span>
          );
        } else {
          return <span>-</span>;
        }
      },
    },

    {
      title: "Cancelled Date",
      dataIndex: "Cancelled",
      key: "Cancelled",
      render: (text, record, index) => {
        const cancelledRecord = record.statusHistory.find(
          (history) => history.resignationStatus === "Cancelled"
        );

        if (cancelledRecord) {
          return (
            <span>
              {moment(cancelledRecord.created_At).format(dateFormat)}
            </span>
          );
        } else {
          return <span>-</span>;
        }
      },
    },
    {
      title: "Attachments",
      dataIndex: "FeedbackAttachment",
      key: "FeedbackAttachment",
      render: (text, record, index) => {
        if (record?.FeedbackAttachment === "") {
          <span>-</span>;
        }
        return (
          <span>
            <a
              href={`${Service.Server_Base_URL}/uploads/Feedbacks/${record?.FeedbackAttachment}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {record?.FeedbackAttachment}
            </a>
          </span>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text, record, index) => {
        const status = record?.resignationStatus;
        if (!status) return null;

        const color =
          record?.resignationStatus == "Pending"
            ? "orange"
            : record?.resignationStatus == "Acknowledged"
              ? "blue"
              : record?.resignationStatus == "Accepted"
                ? "green"
                : "red";

        // The applicant sees exactly what their approvers see - which level
        // has cleared, who is holding it, and the reason if it was turned
        // down. `approval_progress` is present for engine-managed chains and
        // synthesized from statusHistory for older resignations, so the chip
        // is clickable either way; a null falls back to the plain tag.
        return record?.approval_progress ? (
          <ApprovalStatusCell
            progress={record.approval_progress}
            label={capitalizeFirst(status)}
            color={color}
          />
        ) : (
          <Tag color={color}>{capitalizeFirst(status)}</Tag>
        );
      },
    }
  ];



  const handleTableChange = (page, filters, sorter) => {
    setPagination({ ...pagination, ...page });
  };
  const getFooterDetails = () => {
    return (
      <label>
        Total Records Count is {pagination.total > 0 ? pagination.total : 0}
      </label>
    );
  };
  return (
    <div>
      <Modal
        title="Reasons"
        open={isModalOpenView}
        footer={false}
        onOk={handleOkView}
        onCancel={handleCancelView}
      >
        Reason for resignation : {reasonView === ' ' ? '-' : reasonView}
        <br />
        <br />
        Comments for resignation : {commentsView === ' ' ? '-' : commentsView}
        <br />
        <br />
        Reason for revoking : {showreasonRevoke === ' ' ? '-' : showreasonRevoke}
        <br />
        <br />
        Reason for Cancelling : {showReasonCancel === ' ' ? '-' : showReasonCancel}
      </Modal>
      <Card className="employee-card">
        <div className=" inout-header text-left">
          <h2>
            My Resignation data
          </h2>
          <Button onClick={() => history.goBack()} icon={<ArrowLeftOutlined />} type="primary">
            Back
          </Button>
        </div>
        <Card className="main-content-wrapper" >

          <div className="search-wrapper">
            <Search
              ref={searchRef}
              placeholder="Search..."
              onSearch={onSearch}
              onKeyUp={resetSearchFilter}
              style={{ width: 200 }}
              className="mr2"
            />
          </div>
          <div className='main-table-wrapper'>

            <Table
              columns={columns}
              footer={getFooterDetails}
              locale={{ emptyText: <NodataFoundIcon /> }}
              onChange={handleTableChange}
              dataSource={Employees}
              pagination={{ ...TABLE_PAGINATION, ...pagination }}
              onRow={(record) => {
                return {
                  onClick: (event) => {
                    const isActionColumn = event.target.closest('.ant-table-cell')?.classList.contains('actions-column');
                    if (!isActionColumn) {
                      showModalView(
                        record._id,
                        record?.comments,
                        record?.reason,
                        record?.reasonRevoke,
                        record?.reasonCancel
                      );
                    }
                  },
                  style: {
                    cursor: 'pointer'
                  }
                };
              }}
            />
          </div>
        </Card>
      </Card>
    </div>
  );
}

export default UserResignationList;
